'use client';

import 'BomdisoftComponents/tag/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { CloseRoundedIcon } from 'BomdisoftComponents/icons/close-rounded';
import { tagColours } from 'BomdisoftComponents/tag/colour';
import { Tooltip } from 'BomdisoftComponents/tooltip/index';
import type { CSSProperties } from 'react';

export type TagProps = {
  className?: string;
  id?: string;
  label: string;
  onRemove?: () => void;
  removeLabel?: string;
  testId?: string;
};

export const Tag = ({ className, id, label, onRemove, removeLabel = '', testId }: TagProps) => (
  <span className={joinClasses('bomdisoft-tag', className)} data-testid={testId} style={tagColours(id ?? label) as CSSProperties}>
    <span className='bomdisoft-tag-label'>{label}</span>
    {onRemove ? (
      <Tooltip title={removeLabel}>
        <button aria-label={removeLabel} className='bomdisoft-tag-remove' data-testid={testId ? `${testId}-remove` : undefined} onClick={onRemove} type='button'>
          <CloseRoundedIcon size={14} />
        </button>
      </Tooltip>
    ) : null}
  </span>
);
